
import '../css/toknow.scss';

const ToKnow = () => (
  <div className="to-know">
    <div className="content-width">
      <h1>A savoir</h1>
      <div className="to-know-boxes">
        <div className="to-know-box flex3">
          <img src="images/euro.png" alt="Billet d'euros" />
          <p>Paiement en cash ou par carte</p>
        </div>
        <div className="to-know-box flex3">
        <span className="icon mail" />
          <p>Un message vous sera envoyé pour vous confirmer mon arrivée</p>
        </div>
        <div className="to-know-box flex3">
        <span className="icon danger" />
          <p>Navette aéroport: Il est important d’allumer son téléphone à la sortie de l’avion!!</p>
        </div>
      </div>
      <img id="visa" src="images/navette-koffi-presentation.jpg" alt="Lecteur de carte VISA" loading="lazy" />
    </div>
  </div>
);

export default ToKnow;
